import { StyleSheet, View } from "react-native";
import { Text } from "react-native-paper";

import { Callout } from "../blocks/BlockRenderer";
import { CourseIcon } from "../svg/CourseIcon";

import { ScreenHeader } from "./ScreenHeader";

import { courseTheme } from "@/lib/training/courseTheme";
import type { Screen } from "@/lib/training/types";

type HowItWorks = Extract<Screen, { kind: "howItWorks" }>;

// "How this works" screen (CPR_Course_Module1.html lines 304-319).

export function HowItWorksScreen({ screen }: { screen: HowItWorks }) {
    return (
        <View>
            <ScreenHeader
                kicker={screen.kicker ?? ""}
                title={screen.title}
                lede={screen.lede ?? ""}
            />
            <View style={styles.rows}>
                {(screen.rows ?? []).map((r, i) => (
                    <View key={i} style={styles.row}>
                        <View style={styles.ic}>
                            <CourseIcon id={r.icon} size={20} color={courseTheme.tealD} />
                        </View>
                        <View style={styles.rowText}>
                            <Text style={styles.rowTitle}>{r.title}</Text>
                            <Text style={styles.rowSub}>{r.sub}</Text>
                        </View>
                    </View>
                ))}
            </View>
            {screen.callout ? (
                <Callout tone={screen.callout.tone} text={screen.callout.text} />
            ) : null}
        </View>
    );
}

const styles = StyleSheet.create({
    rows: { marginTop: 18, gap: 14 },
    row: { flexDirection: "row", gap: 13, alignItems: "flex-start" },
    ic: {
        width: 40,
        height: 40,
        borderRadius: 12,
        backgroundColor: courseTheme.tealTint,
        alignItems: "center",
        justifyContent: "center"
    },
    rowText: { flex: 1, paddingTop: 2 },
    rowTitle: { fontSize: 15, fontWeight: "800", color: courseTheme.navy },
    rowSub: { fontSize: 13.5, lineHeight: 19, color: courseTheme.slate, marginTop: 2 }
});
